import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";

class Header extends React.Component {
  render() {
    return (
      <div>
        <OwlCarousel
          items={1}
          loop
          animateIn="fadeIn"
          animateOut="fadeOut"
          autoplay
        >
          <div className="item">
            <div className="home d-flex align-items-center">
              <div className="container">
                <div className="columns">
                  <div className="column is-10">
                    <div className="mid-large-text is-hidden-mobile has-text-white">
                      It's all about Improving Businesses.
                    </div>

                    <div className="title is-hidden-desktop has-text-white">
                      It's all about Improving Businesses.
                    </div>
                    <div className="is-size-4 mt-2 has-text-white">
                      Monitor & Manage from Anywhere, Easily Sell Online.
                    </div>

                    <div className="mt-4">
                      <br />
                      <Link to="/signup/">
                        <button className="button is-link">
                          <span className="zmdi zmdi-download mr-2"></span>
                          Download for Free
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="home d-flex align-items-center shop-easy">
              <div className="container">
                <div className="columns">
                  <div className="column is-8 has-text-white">
                    <div className="mid-large-text is-hidden-mobile">
                      And Make Shopping Easy!
                    </div>

                    <div className="title has-text-white is-hidden-desktop">
                      And Make Shopping Easy!
                    </div>
                    <div className="is-size-4 mt-2">
                      From Wherever you are... Shop from the Closest/Favourite
                      Shop.
                    </div>

                    <div className="mt-4">
                      <Link to="/market/">
                        <button className="button is-link">
                          <span className="zmdi zmdi-shopping-cart mr-2"></span>
                          Start Shopping
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
      </div>
    );
  }
}

export default Header;
